export const LEFT_ELEMENT_GAP = 8;